// Утилиты для работы с service-name
import { sessionGet, sessionRemove, sessionSet } from './storage';

const SERVICE_STORAGE_KEY = 'ssmm-service-name';

/**
 * Сохраняет service из URL в sessionStorage
 */
export const saveServiceFromUrl = (): void => {
  const urlParams = new URLSearchParams(window.location.search);
  const service = urlParams.get('service');
  
  if (service) {
    sessionSet(SERVICE_STORAGE_KEY, service);
  }
};

/**
 * Получает service name из URL или sessionStorage
 */
export const getServiceName = (): string | null => {
  // Сначала проверяем URL
  const urlParams = new URLSearchParams(window.location.search);
  const serviceFromUrl = urlParams.get('service');
  
  if (serviceFromUrl) {
    // Обновляем sessionStorage если есть в URL
    sessionSet(SERVICE_STORAGE_KEY, serviceFromUrl);
    return serviceFromUrl;
  }
  
  // Если нет в URL, берём из sessionStorage
  return sessionGet(SERVICE_STORAGE_KEY);
};

/**
 * Возвращает заголовки с service-name если он есть
 */
export const getServiceHeaders = (): Record<string, string> => {
  const service = getServiceName();
  
  if (service) {
    return { 'service-name': service };
  }
  
  return {};
};

/**
 * Очищает сохранённый service
 */
export const clearServiceName = (): void => {
  sessionRemove(SERVICE_STORAGE_KEY);
};

